package cz.aipsafe.safe.frontend.util

import org.w3c.dom.HTMLElement

abstract class Component {
    abstract val element: HTMLElement
}
